<template>
  <div class="featured-collection-preview flex justify-between">
    <div class="imageless-collections">
      <div class="grid-12 grid-column-gap-24 grid-row-gap-8">
        <div
          v-for="item in getImagelessCollections()"
          @click="navigateToCollection(item)"
          class="collection-item span-12-sm span-6-md mx-4"
        >
          {{ item.info.text }}
        </div>
      </div>
    </div>

    <div class="collections-with-images">
      <div class="grid-12 grid-column-gap-24 grid-row-gap-8">
        <div
          v-if="getImageCollections().length"
          class="collection-image-item span-4 span-6-sm"
          @click="navigateToCollection(item)"
          v-for="(item, index) in getImageCollections()"
          :class="{ 'hover-effect': item.info.image_url }"
        >
          <template v-if="item.info.layout === 'IMAGE' && item.info.image_url">
            <img
              v-if="item.info.layout === 'IMAGE'"
              :src="$utils.getCDNURL({ src: item.info.image_url, w: 300, h: 350, q: 100, fit: 'crop' })"
              class="mb-15 img-entity overflow-hidden collection-image"
              :class="[`img-entity-${['none', 'retailer', 'round-sm'][index]}`]"
            />
            {{ item.info.text }}
          </template>

          <div
            v-else
            class="img-entity fake-collection-image"
            :class="[`img-entity-${['none', 'retailer', 'round-sm'][index]}`]"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";

.featured-collection-preview {
  background: $color-light-grey;
  border: 2px dashed $color-grey;
  margin-left: -24px;
  margin-right: calc((100vw - 1165px) / 2 * -1);

  .imageless-collections,
  .collections-with-images {
    padding: 40px;
  }

  .imageless-collections {
    width: 45%;
  }
  .collections-with-images {
    width: 55%;
  }

  .collection-item {
    @include transition(color, 100ms, ease-in-out);

    &:hover {
      cursor: pointer;
      color: mix($color-green, #000, 88%) !important;
    }
  }

  .collection-image {
    width: 100%;
    display: block;
    max-height: 355px;
    object-fit: cover;
  }

  .collection-image-item {
    &.hover-effect {
      @include transition(opacity, 100ms, ease-in-out);
      &:hover {
        opacity: 0.3;
        cursor: pointer;
      }
    }
  }

  .fake-collection-image {
    background: $color-grey;
    height: 12vw;
    width: 100%;
    border: unset;
  }
}

@media only screen and (min-width: 992px) {
  .span-12-sm {
    grid-column-end: span 12;
  }
}

@media only screen and (min-width: 992px) {
  .span-6-md {
    grid-column-end: span 6 !important;
  }
}

@media only screen and (max-width: 992px) {
  .span-6-sm {
    grid-column-end: span 6 !important;
  }
}
</style>

<script>
export default {
  props: {
    containerData: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getImagelessCollections,
    getImageCollections,
    navigateToCollection,
  },
};

function getImagelessCollections() {
  return this.containerData?.children_containers[0]?.view_components || [];
}

function getImageCollections() {
  return this.containerData?.children_containers[1]?.view_components || [];
}
function navigateToCollection(item) {
  const link = item.info?.link;

  if (link) {
    const isInnerRoute = link.includes("https://bulletin.co") && link.split("https://bulletin.co")?.length > 1;
    if (isInnerRoute) {
      const routeData = this.$router.resolve(link.split("https://bulletin.co")[1]);
      window.open(routeData.href, "_blank");
    } else {
      window.open(link, "_blank");
    }
  } else {
    let routeData = this.$router.resolve({
      name: "Collection",
      params: {
        collectionName: item?.info.text,
        collectionId: item.entity_id,
      },
      query: { page: 1 },
    });

    window.open(routeData.href, "_blank");
  }
}
</script>
